import { Box, Grid, Typography } from '@mui/material';
import { gridContainer, infoGridItem } from '../Styles/CustodianContactDetailsStyles';
import { labelText, labelTitle } from '../../../assets/styles/appStyles';
import EntityMappedIdViewModel from '../../../Models/custodian/entity-mappedIds-viewmodel';

export default function EntityMappedIdDetails({
  externalSourceMappings,
}: {
  externalSourceMappings: EntityMappedIdViewModel[];
}) {
  return (
    <Grid rowSpacing={3} container sx={gridContainer}>
      {externalSourceMappings?.length > 0 ?
        (externalSourceMappings.map((item, index: number) => (
          <Grid key={index} xs={12} item container sx={infoGridItem}>
            <Grid item xs={2} sx={infoGridItem}>
              <Typography align="left" sx={labelTitle}>
                Mapped Id
              </Typography>
              <Box>
                <Typography sx={labelText}>{item.mappedId ?? '-'}</Typography>
              </Box>
            </Grid>
            <Grid item xs={3} sx={infoGridItem}>
              <Typography align="left" sx={labelTitle}>
                Type
              </Typography>
              <Box>
                <Typography sx={labelText}>{item.sourceType ?? '-'}</Typography>
              </Box>
            </Grid>
            <Grid item xs={2} sx={infoGridItem}>
              <Typography align="left" sx={labelTitle}>
                Source Notes
              </Typography>
              <Box>
                <Typography sx={labelText}>{item.notes ?? '-'}</Typography>
              </Box>
            </Grid>
          </Grid>
        ))) : (<Grid container spacing={2} mt={2} p={2}>
          No Source Id Details
        </Grid>)}
    </Grid>
  );
}
